import { createSelector } from "reselect";

export const getUsuario = (state) => state.usuario;

export const getPermissoes = createSelector(
  getUsuario,
  (state) => state.permissoes
);
export const getPerfil = createSelector(getUsuario, (state) => state.perfil);

export const isUsuarioLogado = createSelector(
  getUsuario,
  (state) => !!state.nome
);
